<template>
  <div>
    <h1>Testimonial List</h1>

    <div
      v-if="isLoading"
      class="alert alert-info">Loading...</div>
    <div
      v-if="deletedItem"
      class="alert alert-success">{{ deletedItem['@id'] }} deleted.</div>
    <div
      v-if="error"
      class="alert alert-danger">{{ error }}</div>

    <p>
      <router-link
        :to="{ name: 'TestimonialCreate' }"
        class="btn btn-primary">Create</router-link>
    </p>

    <table class="table table-responsive table-striped table-hover">
      <thead :key="keyComponent">
        <tr>
          <th>Id</th>
          <th>
            <div class="d-flex aling-items-center justify-content-between">
              Name
              <div @click="sortByName">
                <span
                  v-if="sortName == 'asc'"
                  class="fas fa-sort-up"
                  aria-hidden="true"></span>
                <span
                  v-if="sortName == 'desc'"
                  class="fas fa-sort-down" 
                  aria-hidden="true"></span>
                <span
                  v-if="sortName == null"
                  class="fas fa-sort" 
                  aria-hidden="true"></span>                  
              </div>
            </div>                    
          </th>
          <th>
            <div class="d-flex aling-items-center justify-content-between">
              Created
              <div @click="sortByCreated">
                <span
                  v-if="sortCreated == 'asc'"
                  class="fas fa-sort-up"
                  aria-hidden="true"></span>
                <span
                  v-if="sortCreated == 'desc'"
                  class="fas fa-sort-down" 
                  aria-hidden="true"></span>
                <span
                  v-if="sortCreated == null"
                  class="fas fa-sort" 
                  aria-hidden="true"></span>                  
              </div>
            </div>                    
          </th>
          <th>Message</th>
          <th>Audio</th>
          <th>Video</th>
          <th>IsValid</th>
          <th>View</th>
          <th>Edit</th>          
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in testimonialItems"
          :key="item['@id']">
          <th scope="row">
            <router-link
              v-if="item"
              :to="{name: 'TestimonialShow', params: { id: item['@id'] }}">
              {{ item['id'] }}
            </router-link>
          </th>
        <td>
            {{ item['name'] }}
        </td>
        <td>
            {{ item['created'] }}
        </td>
        <td>
            {{ item['message'] }}
        </td>
        <td>
            <template v-if="item['audio'] != undefined">        
              <router-link                                
                :to="{name: 'AudioShow', params: { id: item['audio']['@id'] }}">
                {{ item['audio'].name }}
              </router-link>
            </template>
        </td>
        <td>
            <template v-if="item['video'] != undefined">     
              <router-link                
                :to="{name: 'VideoShow', params: { id: item['video']['@id'] }}">
                {{ item['video'].name }}
              </router-link>
            </template>
        </td>         
        <td>            
          <div v-if="item['isValid']">
            <i class="testimonial-icon-valid-true fas fa-check-circle"></i>
          </div>
          <div v-else>
            <i class="testimonial-icon-valid-false fas fa-times-circle"></i>
          </div>
        </td>
          <td>
            <router-link
              :to="{name: 'TestimonialShow', params: { id: item['@id'] }}">
              <span
                class="fa fa-search"
                aria-hidden="true"></span>
              <span class="sr-only">Show</span>
            </router-link>
          </td>
          <td>
            <router-link :to="{name: 'TestimonialUpdate', params: { id: item['@id'] }}">
              <span
                class="fas fa-edit"
                aria-hidden="true"></span>
              <span class="sr-only">Edit</span>
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>

    <nav class="my-3" aria-label="Page navigation" v-if="view">
      <router-link
        :to="view['hydra:first'] ? view['hydra:first'] : 'TestimonialContactList'"
        :class="{ disabled: !view['hydra:previous'] }"
        class="btn btn-primary">
        <span aria-hidden="true">&lArr;</span> <span class="d-none d-sm-inline">First</span>
      </router-link>
      &nbsp;
      <router-link
        :to="!view['hydra:previous']? 'testimonials' : view['hydra:previous']"        
        :class="{ disabled: !view['hydra:previous'] }"
        class="btn btn-primary">
        <span aria-hidden="true">&larr;</span> <span class="d-none d-sm-inline">Previous</span>
      </router-link>

      <router-link
        :to="view['hydra:next'] ? view['hydra:next'] : '#'"
        :class="{ disabled: !view['hydra:next'] }"
        class="btn btn-primary">
        Next <span aria-hidden="true">&rarr;</span>
      </router-link>

      <router-link
        :to="view['hydra:last'] ? view['hydra:last'] : '#'"
        :class="{ disabled: !view['hydra:next'] }"
        class="btn btn-primary">
        Last <span aria-hidden="true">&rArr;</span>
      </router-link>
    </nav>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  data() {
    return {
      successMessage: false,
      errorMessage: false,       
      testimonialItems: null,
      sortName: null,
      sortCreated: null,
      sortField: null,
      keyComponent: 1
    }
  },
  computed: {
      ...mapFields('testimonial/del', {
          deletedItem: 'deleted',
      }),
      ...mapFields('testimonial/list', {
          error: 'error',
          items: 'items',
          isLoading: 'isLoading',
          view: 'view',
      }),
      routePath(){
        return this.$route.fullPath;
      },
      routeParams(){     
        return this.$route.params;
      },
      routeQuery() {
        return this.$route.query;
      }
  },
  created() {
    if (localStorage.getItem('sortNameTestimonial')) {
      this.sortName = localStorage.getItem('sortNameTestimonial');
      this.sortField = { field: 'name', order: this.sortName };
    }
    if (localStorage.getItem('sortCreatedTestimonial')) {
      this.sortCreated = localStorage.getItem('sortCreatedTestimonial');
      this.sortField = { field: 'created', order: this.sortCreated };
    }
    if (!localStorage.getItem('sortNameTestimonial') && !localStorage.getItem('sortCreatedTestimonial')) {
      this.sortCreated = 'asc'
      this.sortField = { field: 'created', order: this.sortCreated };
    }
  },
  mounted() {
    // For next-previous pagination
    this.fetchTestimonials();
    if (this.routeParams.success) {
      this.successMessage = this.routeParams.success;
    } else if (this.routeParams.error) {
      this.errorMessage = this.routeParams.error;
    } else {
      this.successMessage = false;
      this.successMessage = false;
    }
  },
  watch:{
    routePath(){
      this.getSortedPage({field: this.sortField.field, order:this.sortField.order, page: this.routeQuery.page});
    },
    items() {
      this.testimonialItems = this.items;      
    }
  },
  methods: {
    ...mapActions({
      getPage: 'testimonial/list/default',
      getSortedPage: 'testimonial/list/getSortedItems',
    }),
    sortByName() {
      // Remove other filters 
      this.sortCreated = null;
      localStorage.removeItem("sortCreatedTestimonial");      

      // Filter
      if (this.sortName == 'desc') {
        this.sortName = 'asc';
      } else if (this.sortName == 'asc') {
        this.sortName = 'desc';
      } else {
        this.sortName = 'desc';
      }
      // Save in local storage and in sorField configurator
      localStorage.setItem("sortNameTestimonial", this.sortName);
      this.sortField = { field: 'name', order: this.sortName };
      this.fetchTestimonials();
      
      // Refresh header
      this.keyComponent += 1;
    },
    sortByCreated() {      
      // Remove other filters
      this.sortName = null;
      localStorage.removeItem("sortNameTestimonial");      

      // Filter
      if (this.sortCreated == 'desc') {
        this.sortCreated = 'asc';
      } else if (this.sortCreated == 'asc') {
        this.sortCreated = 'desc';
      } else {
        this.sortCreated = 'desc';
      }
      // Save in local storage and in sorField configurator
      localStorage.setItem("sortCreatedTestimonial", this.sortCreated);
      this.sortField = { field: 'created', order: this.sortCreated };       
      this.fetchTestimonials();      

      // Refresh header
      this.keyComponent += 1;
    },
    fetchTestimonials() {
      if (this.routeQuery && this.routeQuery.page) {
        this.getSortedPage({field: this.sortField.field, order:this.sortField.order, page: this.routeQuery.page});
      } else {
        this.getSortedPage({field: this.sortField.field, order:this.sortField.order})
      }    
    }
  },
};
</script>
<style lang="scss">
  @media only screen and (min-width: 992px) {
    .table {
      display: table;           
      .testimonial-icon-valid-true {
        color: green;
        font-size: 25px;        
      }
      .testimonial-icon-valid-false {
        color: red;
        font-size: 25px;
      }
    }
   

  } 
</style>


// WEBPACK FOOTER //
// src/components/testimonial/List.vue